import { render, staticRenderFns } from "./wxshenheClosePre.vue?vue&type=template&id=526e6483&scoped=true"
import script from "./wxshenheClosePre.vue?vue&type=script&lang=js"
export * from "./wxshenheClosePre.vue?vue&type=script&lang=js"
import style0 from "./wxshenheClosePre.vue?vue&type=style&index=0&id=526e6483&prod&scoped=true&lang=css"
import style1 from "./wxshenheClosePre.vue?vue&type=style&index=1&id=526e6483&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526e6483",
  null
  
)

export default component.exports